export type {
    CustomerDetails,
    GetReceiptDataResponse,
    ProcessAchPaymentRequest,
    ProcessAchPaymentResponse,
    ProcessCardTokenPaymentRequest,
    ProcessCardTokenPaymentResponse,
    RecordTokenRequest,
    RecordTokenResponse,
    TerminalAbortRequest,
    TerminalAbortResponse,
    TerminalSaleRequest,
    TerminalSaleResponse,
    TransactionDetails,
    TransactionDetailsCreateRequest,
    ValorCardTokenizationResponse,
} from './payment.types';

export const CardType = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT',
} as const;

export type CardType = (typeof CardType)[keyof typeof CardType];
